import React from 'react'
import { IIconProps } from 'main/common/components/icons/inner/IIconProps'
import { IconICP } from 'main/common/components/icons/inner/IconICP'

/**
 * ICONE: Ajuda, dúvidas
 *
 * @author renatofs
 */
export const HelpIconCP = (props: IIconProps): JSX.Element => {

    return (
        <IconICP
            iconName={'question-circle'}
            size={props.size}
            color={props.color}
            style={props.style}
            theme={props.theme}
            transitionTime={props.transitionTime}
        />
    )
}
